import { useEffect, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import EventEmitter, {
  SHOW_POPUP_CONFIRMATION,
} from '../../../../helpers/EventEmitter'
import { Image } from '../../../image'
import { PopupAction } from '../../../popup/PopupAction'
import iconThankYou from './location.svg'

export const PopupConfirmation = () => {
  const [isShow, setIsShow] = useState(false)
  const [data, setData] = useState('')

  useEffect(() => {
    const eventAction = (data) => {
      setIsShow(true)
      setData(data)
    }
    EventEmitter.subscribe(SHOW_POPUP_CONFIRMATION, eventAction)
    return () => {
      EventEmitter.unsubscribe(SHOW_POPUP_CONFIRMATION, eventAction)
    }
  }, [])

  const handleClose = () => {
    setIsShow(false)
  }

  return (
    <PopupAction
      title="common.CONFIRMATION"
      isShow={isShow}
      handleClose={handleClose}
      btnCancel={{
        label: 'common.CLOSE',
        event: handleClose,
        isI18n: true,
      }}
    >
      <div className="dFlex">
        <Image
          src={iconThankYou}
          alt="location"
          style={{ width: 50, height: 43 }}
          className="mr3"
        />
        <Translate value={data} dangerousHTML={true} />
      </div>
    </PopupAction>
  )
}
